import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import isChromatic from 'chromatic/isChromatic';

import { LockClosedIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayPayPageEvents } from 'Services/analytics/events/paymentEvents/motorwayPayPageEvents';

import { FAQExpandable } from './FAQExpandable';
import type { FAQSectionProps } from './FAQSection';

const PAYMENT_ASSURANCE_POLICY_LINK =
	'https://help.dealers.motorway.co.uk/hc/en-gb/articles/17923718885788-What-is-Motorway-s-Payment-Assurance-Policy';

export const FAQFirstSection: React.FC<FAQSectionProps> = ({ isLoggedOut }) => {
	return (
		<FAQExpandable
			content={
				<>
					<p>
						Yes! When paying with your own funds, your money is safeguarded in your name, in your own FCA-regulated
						account.
					</p>
					<p>
						This means you’re protected from the risk of suppliers defaulting, and Motorway does not earn any interest
						on your funds. As intermediaries, we never have possession of your funds.
					</p>
					<p>
						With the added protection of our{' '}
						{isLoggedOut ? (
							'Payment Assurance Policy'
						) : (
							<Hyperlink
								as="a"
								href={PAYMENT_ASSURANCE_POLICY_LINK}
								label="Payment Assurance Policy"
								onClick={() => {
									motorwayPayPageEvents<{
										label: string;
									}>({
										customData: {
											label: 'assurance_policy_link',
										},
										name: 'Link clicked',
										schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
										version: SNOWPLOW_EVENTS.CLICK.VERSION,
									});
								}}
								target="_blank"
							/>
						)}
						{', '}
						where we take liability for getting the correct amounts to the correct recipients, e.g. the seller or
						finance provider, you can buy vehicles with total peace of mind.
					</p>
				</>
			}
			defaultIsExpanded={Boolean(isChromatic())}
			heading={'Is my money safe?'}
			icon={LockClosedIcon}
			id={'firstExpandable'}
		/>
	);
};
